export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 0,
  numberOfInstallments: 3,
}
